export default "__VITE_ASSET__DX$ogYHf__"